import { assertStrings } from '#app/lib/assert_types'
import { treq } from '#app/lib/treq'
import { allSearchableTypes } from '#entities/lib/types/entities_types'
import type { EntitiesSearchResponse } from '#server/controllers/search/lib/entities_search'
import type { SearchParams } from '#server/controllers/search/search'
import { getCurrentLang } from '#user/lib/i18n'

export async function searchByTypes ({ search, types = allSearchableTypes, limit = 10, offset = 0, claim }: Pick<SearchParams, 'search' | 'types' | 'limit' | 'offset' | 'claim'>) {
  assertStrings(types)
  return treq('search', 'get', 'default', {
    types,
    lang: getCurrentLang(),
    search,
    claim,
    limit,
    offset,
  })
}

export function searchWorks ({ search, limit, offset }: Pick<SearchParams, 'search' | 'limit' | 'offset'>) {
  return searchByTypes({ types: [ 'works' ], search, limit, offset }) as Promise<EntitiesSearchResponse>
}

export function searchHumans ({ search, limit, offset }: Pick<SearchParams, 'search' | 'limit' | 'offset'>) {
  return searchByTypes({ types: [ 'humans' ], search, limit, offset }) as Promise<EntitiesSearchResponse>
}
